export let algebra_equation = {
  "domain_flags": "16", "message_type": "TransmittableMessageType.steps", "message_index": "0",
  "steps":
    [{
      "domain_flags": null,
      "message_type": "TransmittableMessageType.basic",
      "message_index": "1",
      "step": "x ^ 2 - 2 = x",
      "relies_on_named": null,
      "points": "1",
      "description": null,
      "detailed_step": null
    },
      {
        "domain_flags": null,
        "message_type": "TransmittableMessageType.basic",
        "message_index": "2",
        "step": "x ^ 2 + x - 2 = 0",
        "relies_on_named": null,
        "points": "1",
        "description": null,
        "detailed_step": null
      }, {
      "domain_flags": null,
      "message_type": "TransmittableMessageType.basic",
      "message_index": "3",
      "step": "(x + 2 ) (x - 1) = 0",
      "relies_on_named": null,
      "points": "1",
      "description": null,
      "detailed_step": null
    }],
  "component_to_final_solution": {"x": ["-2", "1"]}, "question_text": null
}
export let algebra_mistakes = [{
  "mistake_type": "1", "message": "There is a mistake; these steps are not equivalent.", "outer_message_index": "0",
  "pertinent_indices": ["1", "2"], "expected_results": {"2": "x^{2} - x - 2 = 0"},
  "actual_results": {"2": "x ^ 2 + x - 2 = 0"}, "extra_fields": null
}]
export let algebra_correction_equation = {
  "domain_flags": "16", "message_type": "TransmittableMessageType.steps",
  "message_index": "4", "steps":
    [{
      "domain_flags": null, "message_type": "TransmittableMessageType.basic",
      "message_index": "6", "step": "x ^ 2 - x - 2 = 0", "relies_on_named": null,
      "points": "1", "description": null, "detailed_step": null
    },
      {
        "domain_flags": null, "message_type": "TransmittableMessageType.basic",
        "message_index": "7",
        "step": "(x - 2 ) (x + 1) = 0",
        "relies_on_named": null, "points": "1", "description": null, "detailed_step": null
      }],
  "component_to_final_solution": {"x": ["2", "-1"]}, "question_text": null
}
export let algebra_student_equation = {
  "domain_flags": "16", "message_type": "TransmittableMessageType.steps",
  "message_index": "8",
  "steps":
    [{
      "domain_flags": null,
      "message_type": "TransmittableMessageType.basic",
      "message_index": "9",
      "step": "x ^ 2 - 2 = x",
      "relies_on_named": null,
      "points": "1",
      "description": null,
      "detailed_step": null
    }, {
      "domain_flags": null,
      "message_type": "TransmittableMessageType.basic",
      "message_index": "10",
      "step": "x ^ 2 + x - 2 = 0",
      "relies_on_named": null,
      "points": "1",
      "description": null,
      "detailed_step": null
    }, {
      "domain_flags": null,
      "message_type": "TransmittableMessageType.basic",
      "message_index": "11",
      "step": "(x + 2 ) (x - 1) = 0",
      "relies_on_named": null,
      "points": "1",
      "description": null,
      "detailed_step": null
    }],
  "component_to_final_solution": {"x": ["2", "-1"]}, "question_text": null
}
export let algebra_student_sol_del = {
  "domain_flags": null,
  "message_type": "TransmittableMessageType.delta_linear",
  "message_index": null,
  "correct_steps": [{
    "domain_flags": null,
    "message_type": "TransmittableMessageType.basic",
    "message_index": "1",
    "step": "x ^ 2 - 2 = x",
    "relies_on_named": null,
    "points": "1",
    "description": null,
    "detailed_step": null
  }],
  "corrected_steps": [{
    "domain_flags": null,
    "message_type": "TransmittableMessageType.basic",
    "message_index": "2",
    "step": "x ^ 2 - x - 2 = 0",
    "relies_on_named": null,
    "points": "1",
    "description": null,
    "detailed_step": null
  }, {
    "domain_flags": null,
    "message_type": "TransmittableMessageType.basic",
    "message_index": "3",
    "step": "(x - 2 ) (x + 1) = 0",
    "relies_on_named": null,
    "points": "1",
    "description": null,
    "detailed_step": null
  }],
  "incorrect_steps": [{
    "domain_flags": null,
    "message_type": "TransmittableMessageType.basic",
    "message_index": "2",
    "step": "x ^ 2 + x - 2 = 0",
    "relies_on_named": null,
    "points": "1",
    "description": null,
    "detailed_step": null
  }, {
    "domain_flags": null,
    "message_type": "TransmittableMessageType.basic",
    "message_index": "3",
    "step": "(x + 2 ) (x - 1) = 0",
    "relies_on_named": null,
    "points": "1",
    "description": null,
    "detailed_step": null
  }],
  "points": "1",
  "points_possible": "3",
  "question_text": null
}

//export let algebr
/*
export let calculus_equ = {
  "domain_flags": null,
  "message_type": "TransmittableMessageType.split",
  "message_index": 12,
  "initial_step": "\\int \\frac {4 x + 3} {2 x^2 + 13 x + 69} dx",
  "split_to_solutions": {
    "\\int \\frac {4 x + 13} {2 x^2 + 13 x + 69} dx": [{
      "domain_flags": null,
      "message_type": "TransmittableMessageType.basic",
      "message_index": 13,
      "step": "\\log(2 x^2 + 13 x +69)",
      "relies_on_named": null,
      "points": "1",
      "description": null,
      "detailed_step": null
    }],
    "\\int \\frac {-10} {2 x^2 + 13 x + 69} dx": [{
      "domain_flags": null,
      "message_type": "TransmittableMessageType.basic",
      "message_index": 14,
      "step": "\\int \\frac {-5} {x^2 + \\frac{13}{2} x + \\frac{69}{2}} dx",
      "relies_on_named": null,
      "points": "1",
      "description": null,
      "detailed_step": null
    }, {
      "domain_flags": null,
      "message_type": "TransmittableMessageType.basic",
      "message_index": 15,
      "step": "\\int \\frac {-5} {u^2 + \\frac{935}{16}} du",
      "relies_on_named": null,
      "points": "1",
      "description": null,
      "detailed_step": null
    }, {
      "domain_flags": null,
      "message_type": "TransmittableMessageType.basic",
      "message_index": 16,
      "step": "\\int \\frac{16}{335} \\frac {1} {\\frac{16}{335} u^2 + 1} du",
      "relies_on_named": null,
      "points": "1",
      "description": null,
      "detailed_step": null
    }, {
      "domain_flags": null,
      "message_type": "TransmittableMessageType.basic",
      "message_index": 17,
      "step": " \\frac{-20}{\\sqrt{335}} \\operatorname{arctan} \\left( \\sqrt{ \\frac{16}{335} } u \\right) ",
      "relies_on_named": null,
      "points": "1",
      "description": null,
      "detailed_step": null
    }, {
      "domain_flags": null,
      "message_type": "TransmittableMessageType.basic",
      "message_index": 18,
      "step": " \\frac{-20}{\\sqrt{335}} \\operatorname{arctan} \\left( \\frac{2}{\\sqrt{335} } \\left( x + \\frac{13}{4} \\right) \\right) ",
      "relies_on_named": null,
      "points": "1",
      "description": null,
      "detailed_step": null
    }]
  },
  "variable_equals": null,
  "extra_fields": null,
  "final_solution": null,
  "initial_split": "\\int \\frac {4 x + 13} {2 x^2 + 13 x + 69} + \\frac {-10} {2 x^2 + 13 x + 69} dx",
  "question_text": null
}
export let calculus_equ = {"domain_flags": null,"message_type": "TransmittableMessageType.split","message_index": "21","extra_fields": {"key_properties": {"9": {"functions": [],"variables": ["x"]},"22": {"functions": [],"variables": ["u"]},"15": {"functions": [],"variables": ["du"]},"17": {"functions": [],"variables": ["u"]},"11": {"functions": [],"variables": ["x"]}},"key_origins": {"17": {"pertinent_indices": ["9","22"],"keys_preceding": ["22"]},"11": {"pertinent_indices": ["9"],"keys_preceding": []}},"key_mappings": {"\\int\\frac{-5 d u}{u^{2}+\\frac{107}{4}}": ["\\int \\frac{4 x+3}{2 x^{2}+13 x+69} d x","\\text { Let } u"],"\\int\\frac{4 x+13}{2 x^{2}+13 x+69}dx": ["\\int \\frac{4 x+3}{2 x^{2}+13 x+69} d x"]},"unfound_keys": ["d u"],"key_order": ["\\int \\frac{4 x+3}{2 x^{2}+13 x+69} d x","\\text { Let } u","d u","\\int\\frac{-5 d u}{u^{2}+\\frac{107}{4}}","\\int\\frac{4 x+13}{2 x^{2}+13 x+69}dx"]},"split_to_solutions": {"\\int \\frac{4 x+3}{2 x^{2}+13 x+69} d x": [{"domain_flags": null,"message_type": "TransmittableMessageType.basic","message_index": "9","extra_fields": {"functions": [],"variables": ["x"]},"step": "\\int \\frac{4 x+13}{2 x^{2}+13 x+69}-\\frac{10}{2 x^{2}+13 x+69} d x","relies_on_named": null,"points": null,"description": null,"detailed_step": null,"undefined_functions": null},{"domain_flags": null,"message_type": "TransmittableMessageType.basic","message_index": "20","extra_fields": {"functions": [],"variables": ["x"],"depends_on": {"keys_preceding": ["11"]}},"step": "\\ln(2x^2+13x+69)-\\frac{10}{\\sqrt{107}}\\arctan(\\frac{2}{\\sqrt{107}}\\left(x+\\frac{13}{4}\\right))","relies_on_named": null,"points": null,"description": null,"detailed_step": null,"undefined_functions": null}],"\\text { Let } u": [{"domain_flags": null,"message_type": "TransmittableMessageType.basic","message_index": "22","extra_fields": {"functions": [],"variables": ["x"],"depends_on": {"indices": ["22"],"keys_preceding": ["22"]}},"step": "x+\\frac{13}{4}","relies_on_named": null,"points": null,"description": null,"detailed_step": null,"undefined_functions": null}],"d u": [{"domain_flags": null,"message_type": "TransmittableMessageType.basic","message_index": "15","extra_fields": {"functions": [],"variables": ["dx"]},"step": "d x","relies_on_named": null,"points": null,"description": null,"detailed_step": null,"undefined_functions": null}],"\\int\\frac{-5 d u}{u^{2}+\\frac{107}{4}}": [{"domain_flags": null,"message_type": "TransmittableMessageType.basic","message_index": "17","extra_fields": {"functions": [],"variables": ["u"]},"step": "\\frac{-20}{107} \\int \\frac{1}{\\frac{4}{107} u^{2}+1}","relies_on_named": null,"points": null,"description": null,"detailed_step": null,"undefined_functions": null},{"domain_flags": null,"message_type": "TransmittableMessageType.basic","message_index": "18","extra_fields": {"functions": [],"variables": ["u"]},"step": "\\frac{-10}{\\sqrt{107}} \\arctan(\\frac{2}{\\sqrt{107}} u)","relies_on_named": null,"points": null,"description": null,"detailed_step": null,"undefined_functions": null}],"\\int\\frac{4 x+13}{2 x^{2}+13 x+69}dx": [{"domain_flags": null,"message_type": "TransmittableMessageType.basic","message_index": "11","extra_fields": {"functions": [],"variables": ["x"]},"step": "\\ln(2 x^{2}+13 x+69)","relies_on_named": null,"points": null,"description": null,"detailed_step": null,"undefined_functions": null}]},"initial_step": null,"dependents": null,"variable_equals": null,"final_solution": null,"question_text": "Please solve the following for y","points": null}
*/

export let calculus_equ = {
  "domain_flags": null,
  "message_type": "TransmittableMessageType.split",
  "message_index": "21",
  "extra_fields": {
    "key_properties": {
      "9": {"functions": [], "variables": ["x"]},
      "22": {"functions": [], "variables": ["u"]},
      "15": {"functions": [], "variables": ["du"]},
      "17": {"functions": [], "variables": ["u"]},
      "11": {"functions": [], "variables": ["x"]}
    },
    "key_origins": {"11": {"pertinent_indices": ["9"], "keys_preceding": []}},
    "key_mappings": {
      "\\int\\frac{-5 d u}{u^{2}+\\frac{107}{4}}": ["\\text { Let } u", "\\int \\frac{4 x+3}{2 x^{2}+13 x+69} d x"],
      "\\int\\frac{4 x+13}{2 x^{2}+13 x+69}dx": ["\\int \\frac{4 x+3}{2 x^{2}+13 x+69} d x"]
    },
    "unfound_keys": ["d u"],
    "key_order": ["\\int \\frac{4 x+3}{2 x^{2}+13 x+69} d x", "\\text { Let } u", "d u", "\\int\\frac{-5 d u}{u^{2}+\\frac{107}{4}}", "\\int\\frac{4 x+13}{2 x^{2}+13 x+69}dx"]
  },
  "split_to_solutions": {
    "\\int \\frac{4 x+3}{2 x^{2}+13 x+69} d x": [{
      "domain_flags": null,
      "message_type": "TransmittableMessageType.basic",
      "message_index": "9",
      "extra_fields": {"functions": [], "variables": ["x"]},
      "step": "\\int \\frac{4 x+13}{2 x^{2}+13 x+69}-\\frac{10}{2 x^{2}+13 x+69} d x",
      "relies_on_named": null,
      "points": null,
      "description": null,
      "detailed_step": null,
      "undefined_functions": null
    }, {
      "domain_flags": null,
      "message_type": "TransmittableMessageType.basic",
      "message_index": "20",
      "extra_fields": {"functions": [], "variables": ["x"], "depends_on": {"keys_preceding": ["11"]}},
      "step": "\\ln(2x^2+13x+69)-\\frac{10}{\\sqrt{107}}\\arctan(\\frac{2}{\\sqrt{107}}\\left(x+\\frac{13}{4}\\right))",
      "relies_on_named": null,
      "points": null,
      "description": null,
      "detailed_step": null,
      "undefined_functions": null
    }],
    "\\text { Let } u": [{
      "domain_flags": null,
      "message_type": "TransmittableMessageType.basic",
      "message_index": "22",
      "extra_fields": {
        "functions": [],
        "variables": ["x"],
        "depends_on": {"indices": ["22"], "keys_preceding": ["22"]}
      },
      "step": "x+\\frac{13}{4}",
      "relies_on_named": null,
      "points": null,
      "description": null,
      "detailed_step": null,
      "undefined_functions": null
    }],
    "d u": [{
      "domain_flags": null,
      "message_type": "TransmittableMessageType.basic",
      "message_index": "15",
      "extra_fields": {"functions": [], "variables": ["dx"]},
      "step": "d x",
      "relies_on_named": null,
      "points": null,
      "description": null,
      "detailed_step": null,
      "undefined_functions": null
    }],
    "\\int\\frac{-5 d u}{u^{2}+\\frac{107}{4}}": [{
      "domain_flags": null,
      "message_type": "TransmittableMessageType.basic",
      "message_index": "17",
      "extra_fields": {"functions": [], "variables": ["u"]},
      "step": "\\frac{-20}{107} \\int \\frac{1}{\\frac{4}{107} u^{2}+1}",
      "relies_on_named": null,
      "points": null,
      "description": null,
      "detailed_step": null,
      "undefined_functions": null
    }, {
      "domain_flags": null,
      "message_type": "TransmittableMessageType.basic",
      "message_index": "18",
      "extra_fields": {"functions": [], "variables": ["u"]},
      "step": "\\frac{-10}{\\sqrt{107}} \\arctan(\\frac{2}{\\sqrt{107}} u)",
      "relies_on_named": null,
      "points": null,
      "description": null,
      "detailed_step": null,
      "undefined_functions": null
    }],
    "\\int\\frac{4 x+13}{2 x^{2}+13 x+69}dx": [{
      "domain_flags": null,
      "message_type": "TransmittableMessageType.basic",
      "message_index": "11",
      "extra_fields": {"functions": [], "variables": ["x"]},
      "step": "\\ln(2 x^{2}+13 x+69)",
      "relies_on_named": null,
      "points": null,
      "description": null,
      "detailed_step": null,
      "undefined_functions": null
    }]
  },
  "initial_step": null,
  "dependents": null,
  "variable_equals": null,
  "final_solution": null,
  "question_text": "Please solve the following for y",
  "points": null
}

//= {"domain_flags": null,"message_type": "TransmittableMessageType.split","message_index": "21","extra_fields": {"key_properties": {"9": {"functions": [],"variables": ["x"]},"22": {"functions": [],"variables": ["u"]},"15": {"functions": [],"variables": ["du"]},"17": {"functions": [],"variables": ["u"]},"11": {"functions": [],"variables": ["x"]}},"key_origins": {"17": {"pertinent_indices": ["9","22"],"keys_preceding": ["22"]},"11": {"pertinent_indices": ["9"],"keys_preceding": []}},"key_mappings": {"\\int\\frac{-5 d u}{u^{2}+\\frac{107}{4}}": ["\\int \\frac{4 x+3}{2 x^{2}+13 x+69} d x","\\text { Let } u"],"\\int\\frac{4 x+13}{2 x^{2}+13 x+69}dx": ["\\int \\frac{4 x+3}{2 x^{2}+13 x+69} d x"]},"unfound_keys": ["d u"],"key_order": ["\\int \\frac{4 x+3}{2 x^{2}+13 x+69} d x","\\text { Let } u","d u","\\int\\frac{-5 d u}{u^{2}+\\frac{107}{4}}","\\int\\frac{4 x+13}{2 x^{2}+13 x+69}dx"]},"split_to_solutions": {"\\int \\frac{4 x+3}{2 x^{2}+13 x+69} d x": [{"domain_flags": null,"message_type": "TransmittableMessageType.basic","message_index": "9","extra_fields": {"functions": [],"variables": ["x"]},"step": "\\int \\frac{4 x+13}{2 x^{2}+13 x+69}-\\frac{10}{2 x^{2}+13 x+69} d x","relies_on_named": null,"points": null,"description": null,"detailed_step": null,"undefined_functions": null},{"domain_flags": null,"message_type": "TransmittableMessageType.basic","message_index": "20","extra_fields": {"functions": [],"variables": ["x"],"depends_on": {"keys_preceding": ["11"]}},"step": "\\ln(2x^2+13x+69)-\\frac{10}{\\sqrt{107}}\\arctan(\\frac{2}{\\sqrt{107}}\\left(x+\\frac{13}{4}\\right))","relies_on_named": null,"points": null,"description": null,"detailed_step": null,"undefined_functions": null}],"\\text { Let } u": [{"domain_flags": null,"message_type": "TransmittableMessageType.basic","message_index": "22","extra_fields": {"functions": [],"variables": ["x"],"depends_on": {"indices": ["22"],"keys_preceding": ["22"]}},"step": "x+\\frac{13}{4}","relies_on_named": null,"points": null,"description": null,"detailed_step": null,"undefined_functions": null}],"d u": [{"domain_flags": null,"message_type": "TransmittableMessageType.basic","message_index": "15","extra_fields": {"functions": [],"variables": ["dx"]},"step": "d x","relies_on_named": null,"points": null,"description": null,"detailed_step": null,"undefined_functions": null}],"\\int\\frac{-5 d u}{u^{2}+\\frac{107}{4}}": [{"domain_flags": null,"message_type": "TransmittableMessageType.basic","message_index": "17","extra_fields": {"functions": [],"variables": ["u"]},"step": "\\frac{-20}{107} \\int \\frac{1}{\\frac{4}{107} u^{2}+1}","relies_on_named": null,"points": null,"description": null,"detailed_step": null,"undefined_functions": null},{"domain_flags": null,"message_type": "TransmittableMessageType.basic","message_index": "18","extra_fields": {"functions": [],"variables": ["u"]},"step": "\\frac{-10}{\\sqrt{107}} \\arctan(\\frac{2}{\\sqrt{107}} u)","relies_on_named": null,"points": null,"description": null,"detailed_step": null,"undefined_functions": null}],"\\int\\frac{4 x+13}{2 x^{2}+13 x+69}dx": [{"domain_flags": null,"message_type": "TransmittableMessageType.basic","message_index": "11","extra_fields": {"functions": [],"variables": ["x"]},"step": "\\ln(2 x^{2}+13 x+69)","relies_on_named": null,"points": null,"description": null,"detailed_step": null,"undefined_functions": null}]},"initial_step": null,"dependents": null,"variable_equals": null,"final_solution": null,"question_text": "Please solve the following for y","points": null}
export let calculus_mistakes = [{
  "message": "Steps are not equivalent",
  "outer_message_index": "21",
  "mistake_type": "MistakeType.substitution",
  "deducted_proportion": "1",
  "points_for_correct": null,
  "pertinent_indices": ["0", "1", "22", "20"],
  "expected_results": {"20": "\\ln(13 x + 2 x^{2} + 69) + \\frac{-160 \\sqrt{107} \\operatorname{atan}(\\frac{\\sqrt{107} (4 x + 13)} {214})} {107}"},
  "actual_results": {"20": "\\ln(13 x + 2 x^{2} + 69) + \\frac{-10 \\sqrt{107} \\operatorname{atan}(\\frac{2 \\sqrt{107} (4 x + 13)} {428})} {107}"},
  "extra_fields": null,
  "temp_fields": null
}, {
  "message": "Expecting answer to include a constant of integration",
  "outer_message_index": "21",
  "mistake_type": "MistakeType.missing_constant_of_integration",
  "deducted_proportion": "1",
  "points_for_correct": null,
  "pertinent_indices": null,
  "expected_results": {"20": "\\ln(13 x + 2 x^{2} + 69) + \\frac{-160 \\sqrt{107} \\operatorname{atan}(\\frac{\\sqrt{107} (4 x + 13)} {214})} {107}+ C"},
  "actual_results": {"20": "\\ln(13 x + 2 x^{2} + 69) + \\frac{-10 \\sqrt{107} \\operatorname{atan}(\\frac{2 \\sqrt{107} (4 x + 13)} {428})} {107}"},
  "extra_fields": null,
  "temp_fields": null
}, {
  "message": "Expecting answer to include a constant of integration",
  "outer_message_index": "21",
  "mistake_type": "MistakeType.missing_constant_of_integration",
  "deducted_proportion": "1",
  "points_for_correct": null,
  "pertinent_indices": null,
  "expected_results": {"18": "\\frac{-10 \\sqrt{107} \\operatorname{atan}(\\frac{2 u \\sqrt{107}} {107})} {107} + C"},
  "actual_results": {"18": "\\frac{-10 \\sqrt{107} \\operatorname{atan}(\\frac{2 u \\sqrt{107}} {107})} {107}"},
  "extra_fields": null,
  "temp_fields": null
}, {
  "message": "Expecting answer to include a constant of integration",
  "outer_message_index": "21",
  "mistake_type": "MistakeType.missing_constant_of_integration",
  "deducted_proportion": "1",
  "points_for_correct": null,
  "pertinent_indices": null,
  "expected_results": {"11": "\\ln(13 x + 2 x^{2} + 69) + C"},
  "actual_results": {"11": "\\ln(13 x + 2 x^{2} + 69)"},
  "extra_fields": null,
  "temp_fields": null
}, {
  "message": "Arithmetically incorrect substitution",
  "outer_message_index": "21",
  "mistake_type": "MistakeType.substitution",
  "deducted_proportion": "1",
  "points_for_correct": null,
  "pertinent_indices": ["9", "22"],
  "expected_results": {"-17": "-5 \\int   \\frac{1}{16 u^{2} + 383} d u"},
  "actual_results": {"-17": "\\int   \\frac{-20} {4 u^{2} + 107} d u"},
  "extra_fields": {"keys_preceding": ["22", "17"]},
  "temp_fields": null
}]


export let calculus_mistakes_old = [{
  "message": "Steps are not equal",
  "outer_message_index": "21",
  "mistake_type": "MistakeType.non_equivalence",
  "deducted_proportion": "1",
  "points_for_correct": null,
  "pertinent_indices": ["20", "9"],
  "expected_results": {"20": "\\ln(\\frac{13 x} {2} + x^{2} + \\frac{69}{2}) + \\frac{-20 \\sqrt{383} \\operatorname{atan}(\\frac{4 x \\sqrt{383}} {383} + \\frac{13 \\sqrt{383}} {383})} {383}"},
  "actual_results": {"20": "\\ln(13 x + 2 x^{2} + 69) + \\frac{-10 \\sqrt{107} \\operatorname{atan}(\\frac{2 \\sqrt{107} 4 x + 13} {428})} {107}"},
  "extra_fields": {"keys_preceding": []},
  "temp_fields": null
}, {
  "message": "Expecting answer to include a constant of integration",
  "outer_message_index": "21",
  "mistake_type": "MistakeType.missing_constant_of_integration",
  "deducted_proportion": "1",
  "points_for_correct": null,
  "pertinent_indices": null,
  "expected_results": {"20": "\\ln(\\frac{13 x} {2} + x^{2} + \\frac{69}{2}) + \\frac{-20 \\sqrt{383} \\operatorname{atan}(\\frac{4 x \\sqrt{383}} {383} + \\frac{13 \\sqrt{383}} {383})} {383} + C"},
  "actual_results": {"20": "\\ln(13 x + 2 x^{2} + 69) + \\frac{-10 \\sqrt{107} \\operatorname{atan}(\\frac{2 \\sqrt{107} 4 x + 13} {428})} {107}"},
  "extra_fields": null,
  "temp_fields": null
}, {
  "message": "Substitution is not correct",
  "outer_message_index": "21",
  "mistake_type": "MistakeType.substitution",
  "deducted_proportion": "1",
  "points_for_correct": null,
  "pertinent_indices": ["9", "22"],
  "expected_results": {"-17": "16 \\int   \\frac{1}{16 u^{2} + 383} d u="},
  "actual_results": {"-17": "\\int\\frac{-5 d u}{u^{2}+\\frac{107}{4}}"},
  "extra_fields": {"keys_preceding": ["22", "17"]},
  "temp_fields": null
}, {
  "message": "Expecting answer to include a constant of integration",
  "outer_message_index": "21",
  "mistake_type": "MistakeType.missing_constant_of_integration",
  "deducted_proportion": "1",
  "points_for_correct": null,
  "pertinent_indices": null,
  "expected_results": {"18": "\\frac{-10 \\sqrt{107} \\operatorname{atan}(\\frac{2 u \\sqrt{107}} {107})} {107} + C"},
  "actual_results": {"18": "\\frac{-10 \\sqrt{107} \\operatorname{atan}(\\frac{2 u \\sqrt{107}} {107})} {107}"},
  "extra_fields": null,
  "temp_fields": null
}, {
  "message": "Expecting answer to include a constant of integration",
  "outer_message_index": "21",
  "mistake_type": "MistakeType.missing_constant_of_integration",
  "deducted_proportion": "1",
  "points_for_correct": null,
  "pertinent_indices": null,
  "expected_results": {"11": "\\ln(13 x + 2 x^{2} + 69) + C"},
  "actual_results": {"11": "\\ln(13 x + 2 x^{2} + 69)"},
  "extra_fields": null,
  "temp_fields": null
}]
export let easy_calc_equ = {
  "domain_flags": "16", "message_type": "TransmittableMessageType.steps", "message_index": "0",
  "steps": [{
    "domain_flags": null,
    "message_type": "TransmittableMessageType.basic",
    "message_index": "1",
    "step": "\\int cos( 2 x ) dx",
    "relies_on_named": null,
    "points": "1",
    "description": null,
    "detailed_step": null
  }, {
    "domain_flags": null,
    "message_type": "TransmittableMessageType.basic",
    "message_index": "2",
    "step": " \\frac {sin ( 2 x ) } { 2 }",
    "relies_on_named": null,
    "points": "1",
    "description": null,
    "detailed_step": null
  }], "component_to_final_solution": {"\\int cos( 2 x ) dx": ["\\frac{sin(2 x) }{2}"]}, "question_text": null
}

export let sol_delta = {
  "domain_flags": null, "message_type": "7", "message_index": null,
  "initial_problem": "\\int \\frac {4 x + 3} {2 x^2 + 13 x + 69} dx",
  "correct_steps": {
    "\\int \\frac {-10} {2 x^2 + 13 x + 69} dx":
      [{
        "domain_flags": null,
        "message_type": "2",
        "message_index": 19,
        "step": "\\int \\frac {-5} {x^2 + \\frac{13}{2} x + \\frac{69}{2}} dx",
        "relies_on_named": null,
        "points": null,
        "description": null,
        "detailed_step": null
      }, {
        "domain_flags": null,
        "message_type": "2",
        "message_index": 20,
        "step": "\\int \\frac {-5} {u^2 + \\frac{935}{16}} du",
        "relies_on_named": null,
        "points": null,
        "description": null,
        "detailed_step": null
      }],
    "\\int \\frac {4 x + 13} {2 x^2 + 13 x + 69} dx": [{
      "domain_flags": null,
      "message_type": "2",
      "message_index": 21,
      "step": "\\log(2 x^2 + 13 x +69)",
      "relies_on_named": null,
      "points": "1",
      "description": null,
      "detailed_step": null
    }
    ]
  }, "incorrect_steps": {
    "\\int \\frac {-10} {2 x^2 + 13 x + 69} dx": [{
      "domain_flags": null,
      "message_type": "2",
      "message_index": 22,
      "step": "\\int \\frac{16}{335} \\frac {1} {\\frac{16}{335} u^2 + 1} du",
      "relies_on_named": null,
      "points": null,
      "description": null,
      "detailed_step": null
    },
      {
        "domain_flags": null,
        "message_type": "2",
        "message_index": 23,
        "step": " \\frac{-20}{\\sqrt{335}} \\operatorname{arctan} \\left( \\sqrt{ \\frac{16}{335} } u \\right) ",
        "relies_on_named": null,
        "points": null,
        "description": null,
        "detailed_step": null
      },
      {
        "domain_flags": null,
        "message_type": "2",
        "message_index": 24,
        "step": " \\frac{-20}{\\sqrt{335}} \\operatorname{arctan} \\left( \\frac{2}{\\sqrt{335} } \\left( x + \\frac{13}{4} \\right) \\right) ",
        "relies_on_named": null,
        "points": null,
        "description": null,
        "detailed_step": null
      }
    ],
    "\\int \\frac {4 x + 13} {2 x^2 + 13 x + 69} dx": []
  }, "superfluous_steps": {},
  "missing_steps": {
    "\\int \\frac {-10} {2 x^2 + 13 x + 69} dx": [
      {
        "domain_flags": null,
        "message_type": "2",
        "message_index": 25,
        "step": "\\int \\frac{16}{935} \\frac {1} {\\frac{16}{935} u^2 + 1} du",
        "relies_on_named": null,
        "points": "1",
        "description": null,
        "detailed_step": null
      }, {
        "domain_flags": null,
        "message_type": "2",
        "message_index": 26,
        "step": " \\frac{-20}{\\sqrt{935}} \\operatorname{arctan} \\left( \\sqrt{ \\frac{16}{935} } u \\right) ",
        "relies_on_named": null,
        "points": "1.5",
        "description": null,
        "detailed_step": null
      }, {
        "domain_flags": null,
        "message_type": "2",
        "message_index": 27,
        "step": " \\frac{-20}{\\sqrt{935}} \\operatorname{arctan} \\left( \\frac{2}{\\sqrt{935} } \\left( x + \\frac{13}{4} \\right) \\right) ",
        "relies_on_named": null,
        "points": "1",
        "description": null,
        "detailed_step": null
      }]
  }, "points": "3.0", "points_possible": "6.5", "question_text": null
}

//{  "domain_flags": null ,  "message_type": "7" ,  "message_index": null ,  "initial_problem": "\\int \\frac {4 x + 3} {2 x^2 + 13 x + 69} dx" ,  "correct_steps":   {    "\int \frac {4 x + 13} {2 x^2 + 13 x + 69} dx":     [            {        "domain_flags": null ,        "message_type": "2" ,        "message_index": null ,        "step": "\\log(2 x^2 + 13 x +69)" ,        "relies_on_named": null ,        "points": 1 ,        "description": null ,        "detailed_step": null       }    ] ,    "\int \frac {-10} {2 x^2 + 13 x + 69} dx":     [            {        "domain_flags": null ,        "message_type": "2" ,        "message_index": null ,        "step": "\\int \\frac {-5} {x^2 + \\frac{13}{2} x + \\frac{69}{2}} dx" ,        "relies_on_named": null ,        "points": null ,        "description": null ,        "detailed_step": null       },            {        "domain_flags": null ,        "message_type": "2" ,        "message_index": null ,        "step": "\\int \\frac {-5} {u^2 + \\frac{935}{16}} du" ,        "relies_on_named": null ,        "points": null ,        "description": null ,        "detailed_step": null       }    ]   } ,  "incorrect_steps":   {    "\int \frac {4 x + 13} {2 x^2 + 13 x + 69} dx":     [    ] ,    "\int \frac {-10} {2 x^2 + 13 x + 69} dx":     [            {        "domain_flags": null ,        "message_type": "2" ,        "message_index": null ,        "step": "\\int \\frac{16}{335} \\frac {1} {\\frac{16}{335} u^2 + 1} du" ,        "relies_on_named": null ,        "points": null ,        "description": null ,        "detailed_step": null       },            {        "domain_flags": null ,        "message_type": "2" ,        "message_index": null ,        "step": " \\frac{-20}{\\sqrt{335}} \\operatorname{arctan} \\left( \\sqrt{ \\frac{16}{335} } u \\right) " ,        "relies_on_named": null ,        "points": null ,        "description": null ,        "detailed_step": null       },            {        "domain_flags": null ,        "message_type": "2" ,        "message_index": null ,        "step": " \\frac{-20}{\\sqrt{335}} \\operatorname{arctan} \\left( \\frac{2}{\\sqrt{335} } \\left( x + \\frac{13}{4} \\right) \\right) " ,        "relies_on_named": null ,        "points": null ,        "description": null ,        "detailed_step": null       }    ]   } ,  "superfluous_steps":   {  } ,  "missing_steps":   {    "\int \frac {-10} {2 x^2 + 13 x + 69} dx":     [            {        "domain_flags": null ,        "message_type": "2" ,        "message_index": null ,        "step": "\\int \\frac{16}{935} \\frac {1} {\\frac{16}{935} u^2 + 1} du" ,        "relies_on_named": null ,        "points": 1 ,        "description": null ,        "detailed_step": null       },            {        "domain_flags": null ,        "message_type": "2" ,        "message_index": null ,        "step": " \\frac{-20}{\\sqrt{935}} \\operatorname{arctan} \\left( \\sqrt{ \\frac{16}{935} } u \\right) " ,        "relies_on_named": null ,        "points": 1.5 ,        "description": null ,        "detailed_step": null       },            {        "domain_flags": null ,        "message_type": "2" ,        "message_index": null ,        "step": " \\frac{-20}{\\sqrt{935}} \\operatorname{arctan} \\left( \\frac{2}{\\sqrt{935} } \\left( x + \\frac{13}{4} \\right) \\right) " ,        "relies_on_named": null ,        "points": 1 ,        "description": null ,        "detailed_step": null       }    ]   } ,  "points": 3.0 ,  "points_possible": 6.5 ,  "question_text": null }
//export let
export let sem_sol = {
  "domain_flags": null,
  "message_type": "TransmittableMessageType.semantic_split",
  "message_index": "37",
  "equation_reductions": {
    "d_{y}": [{
      "domain_flags": null,
      "message_type": "TransmittableMessageType.basic",
      "message_index": "31",
      "step": "v_{y} t_{y}",
      "relies_on_named": null,
      "points": null,
      "description": null,
      "detailed_step": null
    }],
    "d_{t}": [{
      "domain_flags": null,
      "message_type": "TransmittableMessageType.basic",
      "message_index": "32",
      "step": "v_{t} t_{t}",
      "relies_on_named": null,
      "points": null,
      "description": null,
      "detailed_step": null
    }],
    "v_{t} t_{y}": [{
      "domain_flags": null,
      "message_type": "TransmittableMessageType.basic",
      "message_index": "33",
      "step": "v_{t} t_{t}",
      "relies_on_named": null,
      "points": null,
      "description": null,
      "detailed_step": null
    }],
    "t_{y}": [{
      "domain_flags": null,
      "message_type": "TransmittableMessageType.basic",
      "message_index": "34",
      "step": "t_{t}+2",
      "relies_on_named": null,
      "points": null,
      "description": null,
      "detailed_step": null
    }],
    "v_{y}(t_{t}+2)": [{
      "domain_flags": null,
      "message_type": "TransmittableMessageType.basic",
      "message_index": "35",
      "step": "v_{t} t_{t}",
      "relies_on_named": null,
      "points": null,
      "description": null,
      "detailed_step": null
    }],
    "v_{t}": [{
      "domain_flags": null,
      "message_type": "TransmittableMessageType.basic",
      "message_index": "28",
      "step": "\\frac{v_{y}(t_{t}+2)}{t_{t}}",
      "relies_on_named": null,
      "points": null,
      "description": null,
      "detailed_step": null
    }]
  },

  "question_text": "You are driving down the highway at 60 mph when a truck passes you. " +
    "Six seconds later, it passes a road sign. Two seconds after that you pass the road sign. " +
    "How fast was the truck going?",
  "sub_solutions": {
    "v_{y}": [{
      "domain_flags": null,
      "message_type": "TransmittableMessageType.basic",
      "message_index": "22",
      "step": "60 mph",
      "relies_on_named": null,
      "points": null,
      "description": null,
      "detailed_step": null
    }],
    "v_{t}": [{
      "domain_flags": null,
      "message_type": "TransmittableMessageType.basic",
      "message_index": "29",
      "step": "\\frac{(60 mph )(8 s )}{6 s }",
      "relies_on_named": null,
      "points": null,
      "description": null,
      "detailed_step": null
    }, {
      "domain_flags": null,
      "message_type": "TransmittableMessageType.basic",
      "message_index": "30",
      "step": "80 mph",
      "relies_on_named": null,
      "points": null,
      "description": null,
      "detailed_step": null
    }]
  },
  "plugin_to_equation_index": {
    "d_{y}": "31",
    "d_{t}": "32",
    "v_{t} t_{y}": "33",
    "t_{y}": "34",
    "v_{y}(t_{t}+2)": "35",
    "v_{t}": "28"
  },
  "mistakes": [],
  "acceptable_mistake": null,
  "extra_fields": null
}
export let sem_corrections = {}
export let sem_delta_correct = {
  "domain_flags": null,
  "message_type": "TransmittableMessageType.delta",
  "message_index": null,
  "initial_problem": "merkah",
  "correct_steps": {
    "d_{t}": [],
    "v_{y}(t_{t}+2)": [{
      "domain_flags": null,
      "message_type": "TransmittableMessageType.basic",
      "message_index": "35",
      "step": "v_{t} t_{t}",
      "relies_on_named": null,
      "points": null,
      "description": null,
      "detailed_step": null
    }],
    "v_{t}": [{
      "domain_flags": null,
      "message_type": "TransmittableMessageType.basic",
      "message_index": "28",
      "step": "\\frac{v_{y}(t_{t}+2)}{t_{t}}",
      "relies_on_named": null,
      "points": null,
      "description": null,
      "detailed_step": null
    }],
    "d_{y}": [],
    "t_{y}": [{
      "domain_flags": null,
      "message_type": "TransmittableMessageType.basic",
      "message_index": "34",
      "step": "t_{t}+2",
      "relies_on_named": null,
      "points": null,
      "description": null,
      "detailed_step": null
    }],
    "v_{y} t_{y}": []
  },
  "incorrect_steps": {
    "d_{t}": [{
      "domain_flags": null,
      "message_type": "TransmittableMessageType.basic",
      "message_index": "32",
      "step": "v_{t} t_{t}",
      "relies_on_named": null,
      "points": null,
      "description": null,
      "detailed_step": null
    }],
    "v_{y}(t_{t}+2)": [],
    "v_{t}": [{
      "domain_flags": null,
      "message_type": "TransmittableMessageType.basic",
      "message_index": "29",
      "step": "\\frac{(60 mph )(8 s )}{6 s }",
      "relies_on_named": null,
      "points": null,
      "description": null,
      "detailed_step": null
    }, {
      "domain_flags": null,
      "message_type": "TransmittableMessageType.basic",
      "message_index": "30",
      "step": "80 mph",
      "relies_on_named": null,
      "points": null,
      "description": null,
      "detailed_step": null
    }],
    "d_{y}": [{
      "domain_flags": null,
      "message_type": "TransmittableMessageType.basic",
      "message_index": "31",
      "step": "v_{y} t_{y}",
      "relies_on_named": null,
      "points": null,
      "description": null,
      "detailed_step": null
    }],
    "t_{y}": [],
    "v_{y} t_{y}": [{
      "domain_flags": null,
      "message_type": "TransmittableMessageType.basic",
      "message_index": "33",
      "step": "v_{t} t_{t}",
      "relies_on_named": null,
      "points": null,
      "description": null,
      "detailed_step": null
    }]
  },
  "superfluous_steps": {
    "v_{y}": [{
      "domain_flags": null,
      "message_type": "TransmittableMessageType.basic",
      "message_index": "22",
      "step": "60 mph",
      "relies_on_named": null,
      "points": null,
      "description": null,
      "detailed_step": null
    }]
  },
  "missing_steps": {
    "d_{t}": [{
      "domain_flags": null,
      "message_type": "TransmittableMessageType.basic",
      "message_index": "32",
      "step": "v_{t} t_{t}",
      "relies_on_named": null,
      "points": "1.0",
      "description": null,
      "detailed_step": null
    }],
    "d_{y}": [{
      "domain_flags": null,
      "message_type": "TransmittableMessageType.basic",
      "message_index": "31",
      "step": "v_{y} t_{y}",
      "relies_on_named": null,
      "points": "1.0",
      "description": null,
      "detailed_step": null
    }],
    "v_{y} t_{y}": [{
      "domain_flags": null,
      "message_type": "TransmittableMessageType.basic",
      "message_index": "33",
      "step": "v_{t} t_{t}",
      "relies_on_named": null,
      "points": "1.0",
      "description": null,
      "detailed_step": null
    }],
    "t_{y}": [{
      "domain_flags": null,
      "message_type": "TransmittableMessageType.basic",
      "message_index": "34",
      "step": "t_{t}+2",
      "relies_on_named": null,
      "points": "1.0",
      "description": null,
      "detailed_step": null
    }],
    "v_{y}(t_{t}+2)": [{
      "domain_flags": null,
      "message_type": "TransmittableMessageType.basic",
      "message_index": "35",
      "step": "v_{t} t_{t}",
      "relies_on_named": null,
      "points": "1.0",
      "description": null,
      "detailed_step": null
    }]
  },
  "points": "3.0",
  "points_possible": "12.0",
  "mistakes": null,
  "question_text": null
}
//export let sem_stud_sol = {"domain_flags": null,"message_type": "TransmittableMessageType.semantic_split","message_index": "37","equation_reductions": {"d_{y}": [{"domain_flags": null,"message_type": "TransmittableMessageType.basic","message_index": "31","step": "v_{y} t_{y}","relies_on_named": null,"points": null,"description": null,"detailed_step": null}],"d_{t}": [{"domain_flags": null,"message_type": "TransmittableMessageType.basic","message_index": "32","step": "v_{t} t_{t}","relies_on_named": null,"points": null,"description": null,"detailed_step": null}],"v_{y} t_{y}": [{"domain_flags": null,"message_type": "TransmittableMessageType.basic","message_index": "33","step": "v_{t} t_{t}","relies_on_named": null,"points": null,"description": null,"detailed_step": null}],"t_{y}": [{"domain_flags": null,"message_type": "TransmittableMessageType.basic","message_index": "34","step": "t_{t}+2","relies_on_named": null,"points": null,"description": null,"detailed_step": null}],"v_{y}(t_{t}+2)": [{"domain_flags": null,"message_type": "TransmittableMessageType.basic","message_index": "35","step": "v_{t} t_{t}","relies_on_named": null,"points": null,"description": null,"detailed_step": null}],"v_{t}": [{"domain_flags": null,"message_type": "TransmittableMessageType.basic","message_index": "28","step": "\\frac{v_{y}(t_{t}+2)}{t_{t}}","relies_on_named": null,"points": null,"description": null,"detailed_step": null}]},"question_text": "You are driving down the highway at 60 mph when truck A passes you. Two seconds later, if a car passes you, two seconds after that you pass the radar. How fast was the car going?","sub_solutions": {"v_{y}": [{"domain_flags": null,"message_type": "TransmittableMessageType.basic","message_index": "22","step": "60 mph","relies_on_named": null,"points": null,"description": null,"detailed_step": null}],"v_{t}": [{"domain_flags": null,"message_type": "TransmittableMessageType.basic","message_index": "29","step": "\\frac{(60 mph )(8 s )}{6 s }","relies_on_named": null,"points": null,"description": null,"detailed_step": null},{"domain_flags": null,"message_type": "TransmittableMessageType.basic","message_index": "30","step": "80 mph","relies_on_named": null,"points": null,"description": null,"detailed_step": null}]},"plugin_to_equation_index": {},"mistakes": [],"acceptable_mistake": null,"extra_fields": null}
//export let sem_equ_with_mistake = {"domain_flags": null,"message_type": "TransmittableMessageType.split","message_index": "21","extra_fields": {"key_properties": {"9": {"functions": [],"variables": ["x"]},"22": {"functions": [],"variables": ["u"]},"15": {"functions": [],"variables": ["du"]},"17": {"functions": [],"variables": ["u"]},"11": {"functions": [],"variables": ["x"]}},"key_origins": {"17": {"pertinent_indices": ["9","22"],"keys_preceding": ["22"]},"11": {"pertinent_indices": ["9"],"keys_preceding": []}},"key_mappings": {"\\int\\frac{-5 d u}{u^{2}+\\frac{107}{4}}": ["\\int \\frac{4 x+3}{2 x^{2}+13 x+69} d x","\\text { Let } u"],"\\int\\frac{4 x+13}{2 x^{2}+13 x+69}dx": ["\\int \\frac{4 x+3}{2 x^{2}+13 x+69} d x"]},"unfound_keys": ["d u"],"key_order": ["\\int \\frac{4 x+3}{2 x^{2}+13 x+69} d x","\\text { Let } u","d u","\\int\\frac{-5 d u}{u^{2}+\\frac{107}{4}}","\\int\\frac{4 x+13}{2 x^{2}+13 x+69}dx"]},"split_to_solutions": {"\\int \\frac{4 x+3}{2 x^{2}+13 x+69} d x": [{"domain_flags": null,"message_type": "TransmittableMessageType.basic","message_index": "9","extra_fields": {"functions": [],"variables": ["x"]},"step": "\\int \\frac{4 x+13}{2 x^{2}+13 x+69}-\\frac{10}{2 x^{2}+13 x+69} d x","relies_on_named": null,"points": null,"description": null,"detailed_step": null,"undefined_functions": null},{"domain_flags": null,"message_type": "TransmittableMessageType.basic","message_index": "20","extra_fields": {"functions": [],"variables": ["x"],"depends_on": {"keys_preceding": ["11"]}},"step": "\\ln(2x^2+13x+69)-\\frac{10}{\\sqrt{107}}\\arctan(\\frac{2}{\\sqrt{107}}\\left(x+\\frac{13}{4}\\right))","relies_on_named": null,"points": null,"description": null,"detailed_step": null,"undefined_functions": null}],"\\text { Let } u": [{"domain_flags": null,"message_type": "TransmittableMessageType.basic","message_index": "22","extra_fields": {"functions": [],"variables": ["x"],"depends_on": {"indices": ["22"],"keys_preceding": ["22"]}},"step": "x+\\frac{13}{4}","relies_on_named": null,"points": null,"description": null,"detailed_step": null,"undefined_functions": null}],"d u": [{"domain_flags": null,"message_type": "TransmittableMessageType.basic","message_index": "15","extra_fields": {"functions": [],"variables": ["dx"]},"step": "d x","relies_on_named": null,"points": null,"description": null,"detailed_step": null,"undefined_functions": null}],"\\int\\frac{-5 d u}{u^{2}+\\frac{107}{4}}": [{"domain_flags": null,"message_type": "TransmittableMessageType.basic","message_index": "17","extra_fields": {"functions": [],"variables": ["u"]},"step": "\\frac{-20}{107} \\int \\frac{1}{\\frac{4}{107} u^{2}+1}","relies_on_named": null,"points": null,"description": null,"detailed_step": null,"undefined_functions": null},{"domain_flags": null,"message_type": "TransmittableMessageType.basic","message_index": "18","extra_fields": {"functions": [],"variables": ["u"]},"step": "\\frac{-10}{\\sqrt{107}} \\arctan(\\frac{2}{\\sqrt{107}} u)","relies_on_named": null,"points": null,"description": null,"detailed_step": null,"undefined_functions": null}],"\\int\\frac{4 x+13}{2 x^{2}+13 x+69}dx": [{"domain_flags": null,"message_type": "TransmittableMessageType.basic","message_index": "11","extra_fields": {"functions": [],"variables": ["x"]},"step": "\\ln(2 x^{2}+13 x+69)","relies_on_named": null,"points": null,"description": null,"detailed_step": null,"undefined_functions": null}]},"initial_step": null,"dependents": null,"variable_equals": null,"final_solution": null,"question_text": "Please solve the following for y","points": null}
export let sem_equ_with_mistake = {
  "domain_flags": null,
  "message_type": "TransmittableMessageType.semantic_split",
  "message_index": "37",
  "extra_fields": {
    "key_properties": {
      "31": {"functions": [], "variables": ["d_{y}"]},
      "32": {"functions": [], "variables": ["d_{t}"]},
      "33": {"functions": [], "variables": ["t_{y}", "v_{y}"]},
      "34": {"functions": [], "variables": ["t_{y}"]},
      "35": {"functions": [], "variables": ["t_{t}", "v_{y}"]},
      "38": {"functions": [], "variables": ["v_{t}"]}
    },
    "necessary_new_unit_solutions": {},
    "unit_solution_dependencies": {"v_{y}": ["v_{y}"], "v_{t}": []},
    "key_mappings": {
      "d_{y}": ["t_{y}"],
      "d_{t}": ["v_{t}"],
      "v_{y} t_{y}": ["v_{t}"],
      "v_{y}(t_{t}+2)": ["v_{t}"],
      "v_{t}": ["v_{y} t_{y}", "t_{y}"]
    },
    "unfound_keys": [],
    "key_order": ["d_{y}", "d_{t}", "v_{y} t_{y}", "t_{y}", "v_{y}(t_{t}+2)", "v_{t}"]
  },
  "equation_reductions": {
    "d_{y}": [{
      "domain_flags": null,
      "message_type": "TransmittableMessageType.basic",
      "message_index": "31",
      "extra_fields": {"functions": [], "variables": ["t_{y}", "v_{y}"]},
      "step": "v_{y} t_{y}",
      "relies_on_named": null,
      "points": null,
      "description": null,
      "detailed_step": null,
      "undefined_functions": null
    }],
    "d_{t}": [{
      "domain_flags": null,
      "message_type": "TransmittableMessageType.basic",
      "message_index": "32",
      "extra_fields": {"functions": [], "variables": ["t_{t}", "v_{t}"]},
      "step": "v_{t} t_{t}",
      "relies_on_named": null,
      "points": null,
      "description": null,
      "detailed_step": null,
      "undefined_functions": null
    }],
    "v_{y} t_{y}": [{
      "domain_flags": null,
      "message_type": "TransmittableMessageType.basic",
      "message_index": "33",
      "extra_fields": {"functions": [], "variables": ["t_{t}", "v_{t}"]},
      "step": "v_{t} t_{t}",
      "relies_on_named": null,
      "points": null,
      "description": null,
      "detailed_step": null,
      "undefined_functions": null
    }],
    "t_{y}": [{
      "domain_flags": null,
      "message_type": "TransmittableMessageType.basic",
      "message_index": "34",
      "extra_fields": {"functions": [], "variables": ["t_{t}"]},
      "step": "t_{t}+2",
      "relies_on_named": null,
      "points": null,
      "description": null,
      "detailed_step": null,
      "undefined_functions": null
    }],
    "v_{y}(t_{t}+2)": [{
      "domain_flags": null,
      "message_type": "TransmittableMessageType.basic",
      "message_index": "35",
      "extra_fields": {"functions": [], "variables": ["t_{t}", "v_{t}"]},
      "step": "v_{t} t_{t}",
      "relies_on_named": null,
      "points": null,
      "description": null,
      "detailed_step": null,
      "undefined_functions": null
    }],
    "v_{t}": [{
      "domain_flags": null,
      "message_type": "TransmittableMessageType.basic",
      "message_index": "38",
      "extra_fields": {
        "functions": [],
        "variables": ["t_{t}", "t_{y}", "v_{y}"],
        "depends_on": {"indices": ["38", "33"], "keys_preceding": ["38", "33"]}
      },
      "step": "\\frac{t_{y} v_{y}} {t_{t}}",
      "relies_on_named": null,
      "points": null,
      "description": null,
      "detailed_step": null,
      "undefined_functions": null
    }, {
      "domain_flags": null,
      "message_type": "TransmittableMessageType.basic",
      "message_index": "28",
      "extra_fields": {
        "functions": [],
        "variables": ["t_{t}", "v_{y}"],
        "depends_on": {"indices": ["28", "38", "38"], "keys_preceding": ["38"]}
      },
      "step": "\\frac{v_{y}(t_{t}+2)}{t_{t}}",
      "relies_on_named": null,
      "points": null,
      "description": null,
      "detailed_step": null,
      "undefined_functions": null
    }]
  },
  "question_text": "You are driving down the highway at 60 mph when a truck passes you. " +
    "Six seconds later, it passes a road sign. Two seconds after that you pass the road sign. " +
    "How fast was the truck going?",



  "sub_solutions": {
    "v_{y}": [{
      "domain_flags": null,
      "message_type": "TransmittableMessageType.basic",
      "message_index": "22",
      "extra_fields": null,
      "step": "60 mph",
      "relies_on_named": null,
      "points": null,
      "description": null,
      "detailed_step": null,
      "undefined_functions": null
    }],
    "v_{t}": [{
      "domain_flags": null,
      "message_type": "TransmittableMessageType.basic",
      "message_index": "29",
      "extra_fields": null,
      "step": "\\frac{(60 mph )(8 s )}{6 s }",
      "relies_on_named": null,
      "points": null,
      "description": null,
      "detailed_step": null,
      "undefined_functions": null
    }, {
      "domain_flags": null,
      "message_type": "TransmittableMessageType.basic",
      "message_index": "40",
      "extra_fields": null,
      "step": "90 mph",
      "relies_on_named": null,
      "points": null,
      "description": null,
      "detailed_step": null,
      "undefined_functions": null
    }]
  },
  "plugin_to_equation_index": {},
  "mistakes": [],
  "acceptable_mistake": null,
  "points": null,
  "sub_solution_to_exact": null
}
//{"domain_flags": null,"message_type": "TransmittableMessageType.semantic_split","message_index": "37","extra_fields": {"key_properties": {"31": {"functions": [],"variables": ["d_{y}"]},"32": {"functions": [],"variables": ["d_{t}"]},"33": {"functions": [],"variables": ["t_{y}","v_{y}"]},"34": {"functions": [],"variables": ["t_{y}"]},"35": {"functions": [],"variables": ["t_{t}","v_{y}"]},"38": {"functions": [],"variables": ["v_{t}"]}},"necessary_new_unit_solutions": {},"unit_solution_dependencies": {"v_{y}": ["v_{y}"],"v_{t}": []},"key_mappings": {"d_{y}": ["t_{y}"],"d_{t}": ["v_{t}"],"v_{y} t_{y}": ["v_{t}"],"v_{y}(t_{t}+2)": ["v_{t}"],"v_{t}": ["t_{y}","v_{y} t_{y}"]},"unfound_keys": [],"key_order": ["d_{y}","d_{t}","v_{y} t_{y}","t_{y}","v_{y}(t_{t}+2)","v_{t}"]},"equation_reductions": {"d_{y}": [{"domain_flags": null,"message_type": "TransmittableMessageType.basic","message_index": "31","extra_fields": {"functions": [],"variables": ["t_{y}","v_{y}"]},"step": "v_{y} t_{y}","relies_on_named": null,"points": null,"description": null,"detailed_step": null,"undefined_functions": null}],"d_{t}": [{"domain_flags": null,"message_type": "TransmittableMessageType.basic","message_index": "32","extra_fields": {"functions": [],"variables": ["t_{t}","v_{t}"]},"step": "v_{t} t_{t}","relies_on_named": null,"points": null,"description": null,"detailed_step": null,"undefined_functions": null}],"v_{y} t_{y}": [{"domain_flags": null,"message_type": "TransmittableMessageType.basic","message_index": "33","extra_fields": {"functions": [],"variables": ["t_{t}","v_{t}"]},"step": "v_{t} t_{t}","relies_on_named": null,"points": null,"description": null,"detailed_step": null,"undefined_functions": null}],"t_{y}": [{"domain_flags": null,"message_type": "TransmittableMessageType.basic","message_index": "34","extra_fields": {"functions": [],"variables": ["t_{t}"]},"step": "t_{t}+2","relies_on_named": null,"points": null,"description": null,"detailed_step": null,"undefined_functions": null}],"v_{y}(t_{t}+2)": [{"domain_flags": null,"message_type": "TransmittableMessageType.basic","message_index": "35","extra_fields": {"functions": [],"variables": ["t_{t}","v_{t}"]},"step": "v_{t} t_{t}","relies_on_named": null,"points": null,"description": null,"detailed_step": null,"undefined_functions": null}],"v_{t}": [{"domain_flags": null,"message_type": "TransmittableMessageType.basic","message_index": "38","extra_fields": {"functions": [],"variables": ["t_{t}","t_{y}","v_{y}"],"depends_on": {"indices": ["38","33"],"keys_preceding": ["38","33"]}},"step": "\\frac{t_{y} v_{y}} {t_{t}}","relies_on_named": null,"points": null,"description": null,"detailed_step": null,"undefined_functions": null},{"domain_flags": null,"message_type": "TransmittableMessageType.basic","message_index": "28","extra_fields": {"functions": [],"variables": ["t_{t}","v_{y}"],"depends_on": {"indices": ["28","38","38"],"keys_preceding": ["38"]}},"step": "\\frac{v_{y}(t_{t}+2)}{t_{t}}","relies_on_named": null,"points": null,"description": null,"detailed_step": null,"undefined_functions": null}]},"question_text": "You are driving down the highway at 60 mph when truck A passes you. Two seconds later, if a car passes you, two seconds after that you pass the radar. How fast was the car going?","sub_solutions": {"v_{y}": [{"domain_flags": null,"message_type": "TransmittableMessageType.basic","message_index": "22","extra_fields": null,"step": "60 mph","relies_on_named": null,"points": null,"description": null,"detailed_step": null,"undefined_functions": null}],"v_{t}": [{"domain_flags": null,"message_type": "TransmittableMessageType.basic","message_index": "29","extra_fields": null,"step": "\\frac{(60 mph )(8 s )}{6 s }","relies_on_named": null,"points": null,"description": null,"detailed_step": null,"undefined_functions": null},{"domain_flags": null,"message_type": "TransmittableMessageType.basic","message_index": "31","extra_fields": null,"step": "90 mph","relies_on_named": null,"points": null,"description": null,"detailed_step": null,"undefined_functions": null}]},"plugin_to_equation_index": {},"mistakes": [],"acceptable_mistake": null,"points": null,"sub_solution_to_exact": null}
export let mistakes_for_sem = [{
  "message": "Expected 80 mph instead received 90 mph",
  "outer_message_index": "37",
  "mistake_type": "MistakeType.unit_conversion_math_incorrect",
  "deducted_proportion": "1",
  "points_for_correct": null,
  "pertinent_indices": ["29", "40",],
  "expected_results": null,
  "actual_results": null,
  "extra_fields": null,
  "temp_fields": null
}]
